import Image from "next/image";
import React from "react";

export default function MachineDeckSelector({
  machine,
  handleSelectedDeckType,
  deckTypeImage,
  uniqueDeckTypes,
}) {
  // Function to remove " - 3b" from the type
  const remove3b = (type) => {
    return type.replace(' - 3b', '');
  };

  return (
    <div className="deck-selector-wrapper">
      <div className="decks-wrapper">
        <div>
          {machine.decks.length > 0 && <h3>Choose a Scrub System</h3>}
          <div className="scrub-systems-wrapper">
            {uniqueDeckTypes.length > 0 &&
              uniqueDeckTypes.map((item) => (
                <div key={item.id} className="scrub-system">
                  {/* <p>{item.type.data.attributes.description}</p> */}
                  {deckTypeImage && (
                    <>
                      <Image
                      alt={item.type.data.attributes.type + " deck"}
                        src={item.type.data.attributes.image.data.attributes.url}
                        width={300}
                        height={300}
                        onClick={() =>
                          handleSelectedDeckType(item.type.data.attributes.type) 
                        }
                      />
                      <span>{remove3b(item.type.data.attributes.type)}</span> 
                    </>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
